<template lang="pug">
.case-container
  .case-content
    .case-case__title
        .divider
        .title__content
          span {{ $t('案例分享：虫虫拜拜') }}
          span {{ $t('专业上门除虫服务，健康家人，舒适生活。') }}
    .case-case__summary
      div
        i.iconfont.iconhangye
        span {{ $t('广告主行业：家政服务') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场、技术') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('从供应商选择到数据展示的一站式解决方案。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('客户是一个新兴的家政服务业务，想做广告来进行推广，对比传统的广告服务模式他们更想选择一种小而灵活的合作方式，选择价格最优，服务最好，效果最好的媒体供应商。同时想在一个整合的平台内看到从广告投放到用户留资到销售转化的全链路闭环。') }}
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content {{ $t('我们为客户提供了如下解决方案：') }}
        .content 1）{{ $t('贵了么小程序：贵了么小程序上有海量的媒体供应商资源可供选择，我们将客户的需求拆分为价格和服务，在贵了么平台内发布后，从海量竞标者中选择符合客户要求的供应商，为供应商和客户提供合作机会，并审核供应商方案，为客户把关。确定合作后，对供应商的投放进行监督，确保各项执行环节有效落实，避免风险。') }}
        .content 2）{{ $t('Datahub平台：清洗、整理并匹配广告、网站、小程序及销售多方数据，并为客户定制高度灵活的自定义看板，让客户对所有广告营销-销售转化-沉淀用户数据一目了然，同时进行深入的跨渠道漏斗分析。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('客户找到了合适的供应商，效率大幅提升，CPL相比之前的投放模式下降了40%。') }}
  MobileContact
</template>"
<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    MobileContact
  }
}
</script>
